import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { WHITE, BLACK } from '../../../../styles/variables.style';

const Wrapper = styled.div`
  width: 100%;
  border-top: 1px solid ${WHITE};
  display: flex;
  padding: 24px 0;
`;

const Name = styled.h2`
  text-transform: uppercase;
  font-weight: 800;
  font-size: 18px;
  letter-spacing: 1px;
  flex: 1;
  margin: 0;
`;

const RemoveBtn = styled.button`
  position: relative;
  border: none;
  background-color: transparent;
  margin-left: auto;
  cursor: pointer;
`;

const CloseIcon = styled.span`
  position: absolute;
  top: 50%;
  transform: translateY(-50%) rotate(45deg);
  right: 0;
  display: inline-block;
  width: 25px;
  height: 25px;
  color: ${BLACK};
  background-color: transparent;
  border: 1px solid ${WHITE};
  border-radius: 50%;
  vertical-align: middle;
  line-height: 40px;
  padding-left: 12px;

  ::after {
    content: '';
    width: 12px;
    height: 2px;
    background-color: ${WHITE};
    position: absolute;
    top: 51%;
    left: 51%;
    transform: translate(-50%, -50%);
  }

  ::before {
    content: '';
    width: 12px;
    height: 2px;
    background-color: ${WHITE};
    position: absolute;
    top: 51%;
    left: 51%;
    transition: transform 0.3s;
    transform: translate(-50%, -50%) rotate(${({ open }) => (open ? 0 : '90deg')});
  }
`;

const Header = ({ name, onRemove, summary }) => (
  <Wrapper>
    <Name>{name}</Name>
    {!summary && (
      <RemoveBtn onClick={onRemove}>
        <CloseIcon />
      </RemoveBtn>
    )}
  </Wrapper>
);

Header.defaultProps = {
  summary: false,
  onRemove: () => {},
};

Header.propTypes = {
  onRemove: PropTypes.func,
  name: PropTypes.string.isRequired,
  summary: PropTypes.bool,
};

export default Header;



// WEBPACK FOOTER //
// ./src/pages/StylistToolPages/NewVisitPage/Treatments/Header.js